module.exports = __webpack_public_path__ + "img/classic.c4896c6b.svg";